import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=70684e5b&scoped=true"
import script from "./SearchInput.vue?vue&type=script&lang=js"
export * from "./SearchInput.vue?vue&type=script&lang=js"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=70684e5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70684e5b",
  null
  
)

export default component.exports